<div class="date-picker-container">
  <div class="input-group">
    <input placeholder="{{getDateFormat()}}"
           [(ngModel)]="selectedDate"
           ngbDatepicker
           readonly
           (dateSelect)="onDateSelection($event)"
           #d="ngbDatepicker" />
    <button class="btn btn-outline-secondary " (click)="d.toggle()" type="button"><i class="fa fa-calendar"></i></button>
  </div>
</div>

